export default "__VITE_ASSET__9qNyiXf3BXi0A04n6W6ImA__";